import _util from '../../utils/';


const traningGroupService = {
	fetchTraningGroupList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRTrainingGroup/Get',
			params: gets,
			success: resolve,
			error: reject
		})
    },
    editTraningGroup(posts, resolve, reject) {
		_util.request({
			url: '/api/HRTrainingGroup/Put',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
    },
    fetchTraningGronpDetail(gets, resolve, reject){
		_util.request({
			url: '/api/HRTrainingGroup/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	}
};


export default traningGroupService;


// WEBPACK FOOTER //
// ./src/services/Training/traning-group-service.js